import type { CventActivitiesBaseProperties, CventIdentityKey } from './types';

/**
 * Cvent identity gate for Cvent analytics publishing.
 *
 * All identifiers are required: an activity is only meaningful to the Cvent analytics
 * pipeline when it can be attributed to a Cvent account, invitee, event and session.
 * Goldcast-native events carry none of them, which is what makes the whole
 * pipeline a safe no-op there.
 */
export const REQUIRED_IDENTITY_KEYS: readonly CventIdentityKey[] = [
  'accountMappingId',
  'attendeeId',
  'eventId',
  'sessionId'
] as const;

/** Identity keys absent from the given base properties, in declaration order. */
export function getMissingIdentityKeys(baseProperties?: CventActivitiesBaseProperties | null): CventIdentityKey[] {
  return REQUIRED_IDENTITY_KEYS.filter(key => !baseProperties?.[key]);
}

/** Whether Cvent analytics facts can be published for the given base properties. */
export function canPublish(baseProperties?: CventActivitiesBaseProperties | null): boolean {
  return getMissingIdentityKeys(baseProperties).length === 0;
}
